/**
 * Pure filter for the "writers you follow" feed.
 * Callers must pass rows the reader is allowed to see (the public catalog).
 * Do not query `contents` by another user's author id: those rules only allow
 * the signed-in user to list their own rows, so the feed would come back empty.
 */
import { canViewContentItem } from "../features/content/contentAccess";
import {
  CONTENT_STATUS,
  exploreSlugToType,
  isUnifiedCatalogSlug,
  normalizeContentType,
  typeToExploreSlug,
} from "../features/content/contentConstants";

export function contentOwnerId(item) {
  return item?.authorId || item?.createdBy || "";
}

export function filterFollowingFeed(rows, followingIds, { contentType = null, viewerUser = null } = {}) {
  const allow = new Set((followingIds || []).filter(Boolean));
  const typeFilter =
    contentType && !isUnifiedCatalogSlug(contentType) ? exploreSlugToType(contentType) : null;
  const byId = new Map();

  for (const item of rows || []) {
    const id = item?.id;
    if (!id || byId.has(id)) continue;
    const owner = contentOwnerId(item);
    if (!allow.has(owner)) continue;
    if (String(item?.status || "").toLowerCase() !== CONTENT_STATUS.PUBLISHED) continue;
    if (typeFilter && normalizeContentType(item.type) !== typeFilter) continue;
    if (viewerUser && !canViewContentItem(item, viewerUser)) continue;
    byId.set(id, {
      ...item,
      id,
      contentType: typeToExploreSlug(normalizeContentType(item.type)),
    });
  }

  return Array.from(byId.values()).sort(
    (a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime()
  );
}
